<template>
    <div>
    </div>
</template>
<script>
export default {
    name: 'dashboard-view'
}
</script>